import { AfterViewInit, ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { SettingsService } from "../../../services/settings.service";
import { Observable, of, Subscription } from "rxjs";
import { ActionButton } from "../../../shared/components/paginated-data-table/action-button.model";
import { Actions } from "@ngrx/effects";
import { LayoutService } from "../../../shared/components/app-layout/shared-layout/layout.service";
import { ActivatedRoute } from "@angular/router";
import { NotificationService } from "../../../services/notification.service";
import { Store } from "@ngrx/store";
import { AppState } from "../../../store";
import { StoreItemActions } from "../../../store/entities/store-item/store-item.actions";
import { StoreItemEntity } from "../../../store/entities/store-item/store-item.model";
import { selectStoreItems } from "../../../store/entities/store-item/store-item.selectors";
import {
  ACTIVATE_OR_DEACTIVATE_USER_MUTATION,
  CREATE_USER_MUTATION,
  DELETE_USER_MUTATION,
  GET_ALL_USER,
  UPDATE_USER_MUTATION
} from "../../../store/entities/user-management/users/users.graphql";
import { User } from "../../../store/entities/user-management/users/users.model";
import {
  SystemUserRole
} from "../../../store/entities/system-configurations/temp-fcrs/system-user-role/system-user-role.model";
import { SystemRolesAddComponent } from "../system-roles-list/system-roles-add/system-roles-add.component";
import { UserAddComponent } from "./user-add/user-add.component";
import { GraphqlService } from '../../../services/graphql.service';
import { TableConfiguration } from '../../../shared/components/paginated-data-table/paginated-table-configuration.model';
import { concat } from 'rxjs/operators';
import { UserViewComponent } from "./user-view/user-view.component";
import {
  WarehouseTransferPersonComponent
} from "../../warehouse-management/warehouses-list/warehouse-view/warehouse-assignee-list/warehouse-transfer-person/warehouse-transfer-person.component";
import {
  WarehouseAssignPersonComponent
} from "../../warehouse-management/warehouses-list/warehouse-view/warehouse-assignee-list/warehouse-assign-person/warehouse-assign-person.component";
import {
  GET_ASSIGNED_PERSON_IN_WAREHOUSE,
  REMOVE_ASSIGNED_PERSON_FROM_WAREHOUSE,
  REMOVE_PERSON_TO_WAREHOUSE
} from "../../../store/entities/warehouse-management/warehouse-assignee/warehouse-assignee.graphql";

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrl: './users-list.component.scss'
})
export class UsersListComponent implements OnInit, OnDestroy {


  loading: boolean;
  viewDetails: boolean;
  addPermission: string[] = ['can_create_user'];
  viewDetailsTitle: string;
  viewType: string;
  selectedUuid: string;
  query;
  tableColumns: object
  tableDataUser$: Observable<User[]>
  searchKeys = ["name"];
  routeSub = Subscription.EMPTY;
  subscription$: Subscription = new Subscription();
  actions$: Actions = inject(Actions);
  filters

  title: string
  filter

  isLoading: boolean
  warehouseTabs: any;
  selectedTabIndex=2;
  fetchAllItemsPerPage = 1000;

  constructor(
    private layoutService: LayoutService,
    private activeRoute: ActivatedRoute,
    private notificationService: NotificationService,
    private store: Store<AppState>,
    private apollo: GraphqlService,
    private settingsService: SettingsService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.title = '   ';
    this.selectEvent(2)
    this.fetchWarehouseUsers();
    this.filter = this.activeRoute.snapshot.queryParams['filter']
  }
 


  async fetchWarehouseUsers() {
    this.isLoading = true;

    try {
      const [allUsersResult, inactiveUsersResult, unassignedResult, assignedResult]: any = await Promise.all([
        this.apollo.query({
          query: GET_ALL_USER,
          variables: {
            filtering: {
              pageNumber: 1,
              itemsPerPage: this.fetchAllItemsPerPage,
              isActive: true
            }
          }
        }),
        this.apollo.query({
          query: GET_ALL_USER,
          variables: {
            filtering: {
              pageNumber: 1,
              itemsPerPage: this.fetchAllItemsPerPage,
              isActive: false
            }
          }
        }),
        this.apollo.query({
          query: GET_ALL_USER,
          variables: {
            filtering: {
              pageNumber: 1,
              itemsPerPage: this.fetchAllItemsPerPage,
              isWarehouseAssigned: false
            }
          }
        }),
        this.apollo.query({
          query: GET_ASSIGNED_PERSON_IN_WAREHOUSE,
          variables: {
            filtering: {
              pageNumber: 1,
              itemsPerPage: this.fetchAllItemsPerPage
            }
          }
        }),
      ]);

      const allUsers = allUsersResult?.data?.getAllUsers?.data ?? [];
      const inactiveUsers = inactiveUsersResult?.data?.getAllUsers?.data ?? [];
      const unassignedUsers = unassignedResult?.data?.getAllUsers?.data ?? [];
      const assignedGroups = assignedResult?.data?.getAllWarehouseUsers?.data ?? [];

      const allUsersTab = {
        warehouse: 'All Users',
        warehouseUniqueId: null,
        tabType: 'all',
        users: allUsers.map(user => this.mapUser(user))
      };

      const inactiveTab = {
        warehouse: 'Inactive Users',
        warehouseUniqueId: null,
        tabType: 'inactive',
        users: inactiveUsers.map(user => this.mapUser(user))
      };

      const unassignedTab = {
        warehouse: 'Unassigned Users',
        warehouseUniqueId: null,
        tabType: 'unassigned',
        users: unassignedUsers.map(user => this.mapUser(user))
      };

      const warehouseTabsMap = new Map();

      assignedGroups.forEach((entry: any) => {
        const key = entry.warehouse;

        if (!warehouseTabsMap.has(key)) {
          warehouseTabsMap.set(key, {
            warehouse: key,
            warehouseUniqueId: entry.warehouseUniqueId,
            tabType: 'assigned',
            users: [],
          });
        }

        warehouseTabsMap.get(key).users.push(
          ...entry.userList.map((user: any) => ({
            ...this.mapUser(user),
            warehouseUniqueId: entry.warehouseUniqueId
          }))
        );
      });

      const sortedWarehouseTabs = Array.from(warehouseTabsMap.values()).sort((a, b) =>
        a.warehouse.localeCompare(b.warehouse)
      );
      const filter =  this.activeRoute.snapshot.queryParams['filter']
      this.selectedTabIndex = filter === 'inactive' ? 1 : 0

      this.warehouseTabs = [
        allUsersTab,
        inactiveTab,
        unassignedTab,
        ...sortedWarehouseTabs
      ];

    } catch (error) {
      this.notificationService.errorMessage(error.message || 'Failed to fetch users');
    } finally {
      this.isLoading = false;
    }
  }

  mapUser(user: any) {
    return {
      ...user,
      userFullName: `${user.firstName} ${user.lastName}`,
      accountType: user.accountType?.replaceAll("_", " "),
      isActive: user.isActive ? "Active" : "Deactivated",
      role: user.role?.roleName
    };
  }

  private actionButtonCache = new Map();

  getActionButtons(tab: any): ActionButton[] {
    if (this.actionButtonCache.has(tab.warehouse)) {
      return this.actionButtonCache.get(tab.warehouse);
    }

    const dynamicActivateDeactivateAction: ActionButton = {
      id: 'activateDeactivate',
      label: tab.tabType === 'inactive' ? 'Activate' : 'Deactivate',
      title: tab.tabType === 'inactive' ? 'Activate' : 'Deactivate',
      icon: tab.tabType === 'inactive' ? 'visibility' : 'visibility_off',
      action: 'activateDeactivate',
      confirm_first: false,
      loading_message: ''
    };

    const baseActions: ActionButton[] = [
      {
        id: 'more',
        label: 'View',
        title: 'View',
        icon: 'visibility',
        action: 'more',
        confirm_first: false,
        loading_message: ''
      },
      dynamicActivateDeactivateAction,
      {
        id: 'edit',
        label: 'Edit',
        title: 'Edit',
        icon: 'edit',
        action: 'edit',
        confirm_first: false,
        loading_message: ''
      },
      {
        id: 'delete',
        label: 'Delete',
        title: 'Delete',
        icon: 'delete',
        action: 'delete',
        confirm_first: false,
        loading_message: ''
      }
    ];

    let result: ActionButton[] = [];

    if (tab.tabType === 'unassigned') {
      result = [this.assignWarehouseAction, ...baseActions];
    } else if (tab.tabType === 'assigned') {
      // result = [this.transferAction, ...baseActions];
        result = [this.transferAction, this.unassignWarehouseAction, ...baseActions];
    } else {
      result = baseActions;
    }

    this.actionButtonCache.set(tab.warehouse, result);
    return result;
  }

  onView(evt: any) {
    this.viewDetailsTitle = "User Details"
    this.settingsService.openDialogModal({
      data: {
        user: evt
      },
      component: UserViewComponent,
    })
  }

  async onDelete(user) {

    if (!user?.uniqueId) {
      console.error('uniqueId is missing or undefined');
      return;
    }

    this.notificationService.confirmation({ message: 'Are you sure?, Caution: System wont allow deleted user to be created again using same email!' }).then(
      async (data) => {

        if (data) {
          this.store.dispatch(StoreItemActions.removeStoreItem({
            entity: StoreItemEntity.user,
            input: {
              uniqueId: user.uniqueId
            },
            id: user.id,
            mutation: DELETE_USER_MUTATION,

          }));
        }
      }
    );
  }

  async onActivateDeactivate(user) {

    if (!user?.uniqueId) {
      console.error('uniqueId is missing or undefined');
      return;
    }

    this.notificationService.confirmation({ message: 'Are you sure?' }).then(
      async (data) => {
        if (data) {
          this.store.dispatch(StoreItemActions.createUpdateStoreItem({
            isInput: true,
            entity: StoreItemEntity.user,
            input: {
              userUniqueId: user.uniqueId,
              deactivateUser: user.isActive === "Active"
            },
            mutation: ACTIVATE_OR_DEACTIVATE_USER_MUTATION,
          }));

          setTimeout(() => {
            this.fetchWarehouseUsers();
          }, 500);
        }
      }
    );

  }


  onAdd(user: User = null) {

    this.settingsService.openDialogModal({
      data: {
        user: user,
        refresh: this.refreshDataTable
      },
      component: UserAddComponent,
    })
  }

  closePanel() {
    this.layoutService.closePanel();
  }


  ngOnDestroy() {
    this.routeSub.unsubscribe();
    this.subscription$.unsubscribe()
  }

  onTransfer = (data) => {
    this.settingsService.openDialogModal({
      component: WarehouseTransferPersonComponent,
      data: {
        data,
        userUniqueId: data.uniqueId,
        warehouseUniqueId: data.warehouseUniqueId
      }
    });

  }


  assignWarehouse = (data) => {
    this.settingsService.openDialogModal({
      component: WarehouseAssignPersonComponent,
      data: {
        data,
        userUniqueId: data.uniqueId,
      }
    });

  }
async onUnassign(user) {

  if (!user?.uniqueId) {
    console.error('uniqueId is missing or undefined');
    return;
  }


  this.notificationService.confirmation({ 
    message: 'Are you sure you want to unassign this user from the warehouse?' 
  }).then(async (confirmed) => {
    if (confirmed) {

      this.store.dispatch(StoreItemActions.removeStoreItem({
        entity: StoreItemEntity.warehouseAssignee,
        id: user.id || user.uniqueId, 
        input: {
          uniqueId: user.uniqueId 
        },
        mutation: REMOVE_PERSON_TO_WAREHOUSE,
      }));


      setTimeout(() => {
        this.fetchWarehouseUsers();
      }, 800);
    }
  });
}

  customAction(event: any) {
    if (event?.action == 'more') return this.onView(event?.value);
    if (event?.action == 'activateDeactivate') return this.onActivateDeactivate(event?.value);
    if (event?.action == 'transfer') return this.onTransfer(event?.value);
    if (event?.action == 'assignWarehouse') return this.assignWarehouse(event?.value);
      if (event?.action == 'unassignWarehouse') return this.onUnassign(event?.value); 
    if (event?.action == 'delete') return this.onDelete(event?.value);
    if (event?.action == 'edit') return this.onAdd(event?.value);
  }

  upsertAction = StoreItemActions.upsertStoreItem;
  removeAction = StoreItemActions.deleteStoreItem;

  refreshDataTable: boolean = false;
  permissions = {
    more: ['can_view_user'],
    activateDeactivate: ['can_edit_user'],
    transfer: ['can_transfer_warehouse_users'],
    assignWarehouse: ['can_add_warehouse_users'],
    edit: ['can_edit_user'],
    delete: ['can_delete_user'],
        unassignWarehouse: ["can_remove_warehouse_users"],
  }

  tableConfiguration: TableConfiguration = {
    tableColumns: [
      { name: 'userFullName', label: 'Full Name' },
      { name: 'email', label: 'Email' },
      { name: 'phone', label: 'Phone' },
      { name: 'accountType', label: 'Account Type' },
      { name: 'role', label: 'Role' },
      { name: 'isActive', label: 'Status' },


    ],
    tableCaption: '',
    showNumbers: true,
    tableNotifications: 'Notification',
    showSearch: true,
    useFullObject: true,
    showBorder: true,
    allowPagination: true,
    useRowClick: true,
    actionIcons: {
      edit: false,
      delete: false,
      more: false,
      print: false,
      customPrimary: false,
    },
    doneLoading: false,
    deleting: {},
    active: {},
    hideExport: true,
    customPrimaryMessage: 'Activate',
    empty_msg: 'No data found',
  }

  assignWarehouseAction: ActionButton = {
    id: "assignWarehouse",
    label: "Assign Warehouse",
    title: "Assign Warehouse",
    icon: "compare_arrows",
    class: "",
    action: "assignWarehouse",
    confirm_first: false,
    loading_message: "",
  };
  unassignWarehouseAction: ActionButton = {
  id: "unassignWarehouse",
  label: "Unassign",
  title: "Unassign Warehouse",
  icon: "remove_circle",
  class: "",
  action: "unassignWarehouse",
  confirm_first: false,
  loading_message: "",
};

  transferAction: ActionButton = {
    id: "transfer",
    label: "Transfer",
    title: "Transfer",
    icon: "compare_arrows",
    class: "",
    action: "transfer",
    confirm_first: false,
    loading_message: "",
  };

  selectEvent(evt){

    this.selectedTabIndex = evt
    console.log(this.selectedTabIndex);
    
    
  }

}


